import React from "react";

const List = ({ children, theme }) => {
  return (
    <ul
      className={`text-xl lgl:text-lg text-justify tracking-tight lgl:tracking-tight ${
        theme === "dark" ? "text-darkTextDesignColor" : "text-bgColor"
      } font-semibold flex items-center gap-6`}
    >
      {children}
    </ul>
  );
};

export default List;
